export default {
    'deck-bottom': {
        bottom: '140px'
    },
    'discard-bottom': {
        bottom: '155px'
    },
    'discard-top': {
        top: '185px'
    },
    'archives-bottom': {
        bottom: '155px'
    },
    'hand-top': {
        top: '185px'
    },
    'hand-bottom': {
        bottom: '155px'
    },
    'archives-top': {
        top: '185px'
    },
    'purged-top': {
        top: '155px'
    },
    'purged-bottom': {
        bottom: '155px',
        right: '0'
    }
};
